import React from 'react';
import PropTypes from 'prop-types';

const PesosAtivosRow = (props) => {
    return (
        <li className="list-group-item list-group-item-action flex-column align-items-start">
            <div className="row">
                <div className="form-group col-10">
                    <label htmlFor={props.nome}>{props.nome}</label>
                    <input className="form-control" placeholder="peso..." name={props.nome} type="number" step="0.01"
                        value={props.peso} onChange={evt => props.atualizarValor(props.ativo_id, evt.target.value)} />
                </div>
                <button type="button" onClick={() => props.handleRemove(props.ativo_id)} className="btn btn-block btn-danger col-2">
                    <i className="fas fa-times" />
                </button>
            </div>
        </li>
    );
};

PesosAtivosRow.propTypes = {
    nome: PropTypes.string.isRequired,
    peso: PropTypes.number.isRequired,
    ativo_id: PropTypes.number.isRequired,
    handleRemove: PropTypes.func.isRequired,
    atualizarValor: PropTypes.func.isRequired,
};

export default PesosAtivosRow;


// WEBPACK FOOTER //
// ./src/components/pesos/PesosAtivosRow.js